import React from 'react';
import { useNavigate } from 'react-router-dom';
import BrandLogo from '@/components/shared/BrandLogo';
import { resolveTenantBranding } from '@/utils/tenantBranding';

interface TenantBrandBarProps {
  className?: string;
}

/**
 * Slim tenant strip on mobile; logo navigates to dashboard.
 * From sm+ the logo lives in AppShell's single top header row.
 */
const TenantBrandBar: React.FC<TenantBrandBarProps> = ({ className = '' }) => {
  const tenant = resolveTenantBranding();
  const navigate = useNavigate();

  return (
    <div
      className={`relative border-b border-black/5 bg-white ${className}`}
      role="presentation"
      aria-hidden="false"
    >
      <div className={`h-1 w-full ${tenant.accentBarClass}`} aria-hidden="true" />
      <div className="mx-auto flex h-11 max-w-7xl items-center justify-center gap-3 px-4 sm:h-12">
        <button
          type="button"
          onClick={() => navigate('/dashboard')}
          className="rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          aria-label="Go to dashboard"
        >
          <BrandLogo size="sm" variant="default" className="max-h-8 w-full sm:max-h-9" />
        </button>
        {tenant.showPoweredByVaiu ? (
          <div className="absolute right-4 top-1/2 -translate-y-1/2 sm:right-6">
            <PoweredByVaiuMark compact />
          </div>
        ) : null}
      </div>
    </div>
  );
};

export function PoweredByVaiuMark({ compact = false }: { compact?: boolean }) {
  return (
    <div
      className={`flex items-center gap-1 text-muted-foreground ${compact ? 'text-[10px] leading-tight' : 'text-xs'}`}
      title="Powered by Vaiu"
    >
      {!compact && <span className="hidden sm:inline">Powered by</span>}
      <span className="font-semibold text-slate-700">Vaiu</span>
    </div>
  );
}

export default TenantBrandBar;
